module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/necklaces/couture-d89b521abd63f3f7532e539955725265.webp";